import { Component, OnInit, Inject, ViewChild, AfterViewInit, Input, EventEmitter, Output  } from '@angular/core';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import { formatDate } from "@angular/common";

import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';


import { ServicefinService } from '../services/servicefin.service';

import { ReponseWebService } from '../datastruct/Meloyi.module';

import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';


@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {

	@Input() laCompagnie : any ;

	allPartners : any ;

	datedeb : any ;
	datefin : any ;

	userchoice = 1 ;

	allServiceSituation: any ;

    totalIn = 0 ; 
    totalOut =  0 ; 
    totalVersement =  0 ;

	samacaabiyoonwii = "" ;

	dataSourceSituations : MatTableDataSource<any> ;


	displayedColumnsTop :  string[] = [ 'Wave', 'OrangeMoney' , 'Cheque', 'Cash' ] ;
	dataSourceTopAmounts : any ;

	displayedColumns: string[] = [ 'dateload', 'service' , 'montant', 'opt' ] ;
	dataSource : any ;


	lesMontants = [{wave:0, orangemoney:0, cheque:0, cash:0}] ;


	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;

	retourClientWS  : ReponseWebService ;

	constructor(public dialog: MatDialog,  private configServer: ServicefinService, private _adapter: DateAdapter<any>, @Inject(MAT_DATE_LOCALE) private _locale: string) {
	    this.datedeb = new Date(); 
	    this.datefin = new Date(); 
	}

	ngOnInit(): void {
	    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
	    this.getCompagnieSituationsPeriode();
	}



	getCompagnieSituationsPeriode(){

		var debut = formatDate(this.datedeb, "yyyy-MM-dd", 'en-US');
		var fin = formatDate(this.datefin, "yyyy-MM-dd", 'en-US');
		let idComp = this.laCompagnie.idComp ;

		this.configServer.getCompagnieSituationsPeriode(this.samacaabiyoonwii, debut, fin, idComp).then( (retourbi) => {

		  this.retourClientWS = retourbi ;
		  var statutreq = this.retourClientWS.statutreq;

	    console.log("Done85") ;
	    console.log(retourbi)

		  if(statutreq==1){
	        this.lesMontants = this.cumulSituationPeriode(this.retourClientWS.data) ; 
		    this.dataSourceTopAmounts =  new MatTableDataSource(this.lesMontants) ;

		    this.getAllOpsOfCompagnie() ;

		  }
		  else{
		    console.log("Failed") ;
		  }
		}) ;  
	}


	getAllOpsOfCompagnie(){
	    var debut = formatDate(this.datedeb, "yyyy-MM-dd", 'en-US');
	    var fin = formatDate(this.datefin, "yyyy-MM-dd", 'en-US');

	    this.configServer.getAllOpsOfCompagnie(this.samacaabiyoonwii, debut, fin, this.laCompagnie.nomcompagnie).then( (retourbi) => {
	      this.retourClientWS = retourbi ;
	      var statutreq = this.retourClientWS.statutreq;

	      if(statutreq==1){
	        console.log("Done") ;

	        this.dataSource =  new MatTableDataSource(this.retourClientWS.data) ;
	        this.dataSource.paginator = this.paginator;
	        this.dataSource.sort = this.sort;
	      }
	      else{
	        console.log("Failed") ;
	      }
	    }) ;    
	}


	computeBankTotals(){
		console.log("Tjerer .... 147") ;
	    this.totalIn = 0 ; 
	    this.totalOut =  0 ; 
	    this.totalVersement =  0 ;
		for ( var j = 0 ; j < this.allServiceSituation.length ; j++) {
			if(this.laCompagnie.idBank == this.allServiceSituation[j].idBankPart){
				this.totalIn += Number(this.allServiceSituation[j].totalEnvoie) ;
				this.totalOut += Number(this.allServiceSituation[j].totalRetrait) ;
				this.totalVersement += Number(this.allServiceSituation[j].versement) ;		
			}
		}
	}


	getBankOps(){
		console.log("Tjerer .... 147") ;
	    let allBankSituations = [] ; 
	    
		for ( var j = 0 ; j < this.allServiceSituation.length ; j++) {
			if(this.laCompagnie.idBank == this.allServiceSituation[j].idBankPart){
				allBankSituations.push(this.allServiceSituation[j]) ;
			}
		}

		return allBankSituations ;
	}



	  cumulSituationPeriode(situations){
	  	let wave=0;
	  	let orangemoney=0;
	  	let cheque=0;
	  	let cash=0;

	  	for (var i = situations.length - 1; i >= 0; i--) {
	  		wave = wave + Number(situations[i].wave) ;
	  		orangemoney = orangemoney + Number(situations[i].orangemoney) ;
	  		cheque = cheque + Number(situations[i].cheque );
	  		cash = cash + Number(situations[i].cash );
	  	}

	  	return [{wave:wave, orangemoney:orangemoney, cheque:cheque, cash:cash }] ;
	  }


	applyFilter(event: Event) {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSourceSituations.filter = filterValue.trim().toLowerCase();
		this.dataSourceSituations.filter = filterValue.trim().toLowerCase();
	}


	getMontantFormatee(montant){
		let resultd = Number(montant).toLocaleString('fr-FR');
		return resultd ;
	}

	getMontantTotal(){
		let soldebi = Number(this.lesMontants[0].wave)+Number(this.lesMontants[0].orangemoney)+Number(this.lesMontants[0].cheque)+Number(this.lesMontants[0].cash) ;
		return  Number(soldebi).toLocaleString('fr-FR');
	}



}
